/**
 * Category model
 *
 * @class Model_Category
 * @extends Model
 */

Model_Category = (function (Model) {

	var Model_Category = function () {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Model_Category.prototype, Model.prototype, {
		/**
		 * Construct object
		 * @constructor
		 */
		construct: function (attributes) {
			this.data = {};
			this.init();
			this.parseData(attributes);
		},

		/**
		 * Initialize Model_Category
		 */
		init: function () {
			/**
			 * @property {Boolean} fetched - flag for fetching full asset detail and related assets.
			 * NOTE: it's set by Model_Category.fetchFullDetail
			 */
			this.fetched = false;

		},

		parseData: function (data) {
			var category = new Collection_Plays(null, {
				model: Model_Play,
				reqParams: {
				}
			});
			category.setData(data);
			$.extend(true, this.data, category);
		},

		/**
		 * @returns {String} Model id
		 */
		getId: function () {
			return (this.data && this.data.contentKey) ? this.data.contentKey : false;
		},

		/**
		 * @returns {Boolean} return value tells if full asset detail and related assets were fetched
		 */
		isFetched: function () {
			return this.fetched;
		},

		/**
		 * @returns {String} Movie id
		 */
		getID: function () {
			return this.getId();
		},

		/**
		 * @returns {String} Movie title
		 */
		getTitle: function () {
			return this.data.name;
		},
	});

	return Model_Category;

})(Model);



//////////////////
// WEBPACK FOOTER
// ./js/model/category.js
// module id = 44
// module chunks = 0